/**
 * FILTER.JS
 */
import Hideable from "../classes/hideable";

export default function InitFilterSection() {
	const filterButtons = document.querySelectorAll('.filter-buttons button[data-filter-type]');
	if (filterButtons.length === 0) return;

	let filterTypes = [];

	filterButtons.forEach((filterButton) => {
		const filterType = filterButton.dataset.filterType;

		// All are visible from the beginning, on the first click they'll become invisible
		filterTypes[filterType] = false;

		filterButton.addEventListener('click', (event) => {
			event.preventDefault();

			if (filterButton.getAttribute('aria-pressed') === 'true') {
				filterButton.setAttribute('aria-pressed', 'false');
				filterTypes[filterType] = false;
			} else {
				filterButton.setAttribute('aria-pressed', 'true');
				filterTypes[filterType] = true;
			}

			const filterName = ("filterName" in event.target.dataset) ?
					event.target.dataset.filterName :
					null;

			reloadThumbnailVisibility(filterName, filterTypes);
		});
	});
}

/**
 * Checks whether the filter types are set visible and sets the CSS style
 * accordingly.
 *
 * @param filterName
 * @param filterTypes object with filter type as the key and bool as the value
 */
function reloadThumbnailVisibility(filterName, filterTypes) {
	const allInvisible = Object.keys(filterTypes).every((k) => !filterTypes[k]);

	const filterSections = document.querySelectorAll('.filter-items');
	filterSections.forEach((section) => {

		const noResults = section.querySelector('.no-results');
		const noResultsText = new Hideable(noResults, true);

		const filterItems = (filterName) ?
			section.querySelectorAll(`[data-filter-type][data-filter-name="${filterName}"]`) :
			section.querySelectorAll(`[data-filter-type]`);

		let showNoneFound = true;
		filterItems.forEach((filterItem) => {
			const visible = filterItem.dataset.filterType.split(',').some((k) => filterTypes[k]);
			const hideableFilterItem = new Hideable(filterItem, true);
	
			// Show it if it or none is selected, else hide it
			if (allInvisible || visible) {
				showNoneFound = false;
				hideableFilterItem.show();
			}
			else hideableFilterItem.hide();
		});

		if(showNoneFound)
			noResultsText.show();
		else noResultsText.hide();
	});

}
